function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.4346 8.26292C12.3935 8.17173 12.3268 8.09438 12.2427 8.04017C12.1586 7.98595 12.0607 7.95717 11.9606 7.95729H9.87732V1.18707C9.8772 1.11854 9.86358 1.0507 9.83722 0.987447C9.81086 0.92419 9.77228 0.866752 9.7237 0.818419C9.67512 0.770086 9.61748 0.731807 9.55409 0.705772C9.4907 0.679736 9.4228 0.666456 9.35428 0.66669H7.27099C7.13305 0.666926 7.00083 0.721826 6.90329 0.819365C6.80576 0.916903 6.75086 1.04913 6.75062 1.18707V7.95907H4.66733C4.56724 7.95892 4.46925 7.98763 4.38508 8.04177C4.3009 8.09591 4.23411 8.17317 4.19273 8.2643C4.15135 8.35542 4.13714 8.45655 4.15178 8.55556C4.16642 8.65456 4.20929 8.74725 4.27527 8.8225L7.92056 12.9891C7.96932 13.045 8.02952 13.0899 8.09707 13.1206C8.16462 13.1513 8.23796 13.1672 8.31218 13.1672C8.38639 13.1672 8.45975 13.1513 8.5273 13.1206C8.59485 13.0899 8.65505 13.045 8.70381 12.9891L12.3491 8.8225C12.4159 8.74749 12.4596 8.6547 12.4748 8.55538C12.49 8.45607 12.476 8.35447 12.4346 8.26292Z",
  fill: "#666666"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.044 12.1257V15.2506H2.58328V12.1257H0.5V16.2923C0.5 16.5686 0.609744 16.8335 0.80509 17.0288C1.00044 17.2242 1.26538 17.3339 1.54164 17.3339H15.0857C15.2225 17.3341 15.358 17.3072 15.4844 17.2549C15.6108 17.2026 15.7257 17.1259 15.8225 17.0291C15.9192 16.9324 15.9959 16.8175 16.0482 16.691C16.1005 16.5646 16.1274 16.4291 16.1273 16.2923V12.1257H14.044Z",
  fill: "#666666"
});

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.5c7640b0.svg";
export { ForwardRef as ReactComponent };